import EFOcats_error_info from '../../../core/v2/efocats_error_info';
import EFOcats_import_lang from '../../../core/v2/import/efocats_import_lang';
import efocats_validate_core from '../../../core/v2/validate/efocats_validate_core';

/**
 * ひらがなチェッククラス
 */
export default class EFOcats_curves_validate_hiragana extends efocats_validate_core {
  /**
   * エラーチェック
   */
  validate(checkData) {
    let result = new EFOcats_error_info('success', '', '', '');

    // 半角スペースを全角スペースに置換する
    checkData.val(checkData.val().replace(' ', '　'));

    // eslint-disable-next-line no-irregular-whitespace
    if (!checkData.val().match(/^[ぁ-んー　]+$/)) {
      result = new EFOcats_error_info('error', EFOcats_import_lang.getValue('hiraganaerror'), '', EFOcats_import_lang.getValue('hiraganaerror'));
    }

    return result;
  }
}
